import { render } from "./ModelOptions.vue?vue&type=template&id=a7156b60&ts=true"
import script from "./ModelOptions.vue?vue&type=script&lang=ts"
export * from "./ModelOptions.vue?vue&type=script&lang=ts"

import "./ModelOptions.vue?vue&type=style&index=0&id=a7156b60&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__